export default "__VITE_ASSET__BM8Uwjwg__"